import { Modal, Select } from '@enamelai/design-system'
import { readSelectValue } from '@utils/billing.utils'
import React, { useMemo } from 'react'
import { useAddInvoiceModal } from './useAddInvoiceModal.hook'
import './AddInvoiceModal.css'

interface AddInvoiceModalProps {
  isVisible: boolean
  closeModal: () => void
}

const AddInvoiceModal: React.FC<AddInvoiceModalProps> = ({
  isVisible,
  closeModal,
}) => {
  const {
    source,
    patient,
    invoiceNum,
    loading,
    setInvoiceNum,
    filteredPatients,
    invoiceOptions,
    availableSources,
    handleSourceChange,
    handlePatientChange,
    handleAdd,
  } = useAddInvoiceModal({
    isVisible,
    closeModal,
  })

  const patientOptions = useMemo(
    () =>
      filteredPatients.map((p: { name: string }) => ({
        value: p.name,
        label: p.name,
      })),
    [filteredPatients],
  )

  return (
    <Modal
      title="Add invoice"
      open={isVisible}
      onClose={closeModal}
      size="sm"
      closeOnBackdrop={false}
      primaryLabel="Add"
      secondaryLabel="Cancel"
      primaryDisabled={loading || !source || !patient || !invoiceNum}
      onPrimaryClick={handleAdd}
      onSecondaryClick={closeModal}
      bodyClassName="add-invoice-modal-body"
    >
      <div className="d-flex flex-column gap-2">
        <Select
          label="Select source"
          value={source}
          options={availableSources}
          onChange={(value) => handleSourceChange(readSelectValue(value))}
          placeholder="Choose source"
        />
        <Select
          label="Select patient"
          value={patient}
          options={patientOptions}
          disabled={!source || source === 'self'}
          onChange={(value) => handlePatientChange(readSelectValue(value))}
          placeholder="Choose patient"
        />
        <Select
          label="Select invoice number"
          value={invoiceNum}
          options={invoiceOptions}
          disabled={!source || !patient}
          onChange={(value) => setInvoiceNum(readSelectValue(value))}
          placeholder="Choose invoice"
        />
      </div>
    </Modal>
  )
}

export default AddInvoiceModal
